import React from 'react';
import { useCascaderRoot } from '../../../hooks/tree';
import { TreeNode } from './TreeNode';
export function RootNode(props) {
  var _props$nodeKey = props.nodeKey,
      nodeKey = _props$nodeKey === void 0 ? 'id' : _props$nodeKey;
  var root = useCascaderRoot();
  return React.createElement(React.Fragment, null, root.children.map(function (info, index) {
    return React.createElement(TreeNode, {
      id: info.id,
      index: index,
      key: info[nodeKey],
      markKey: info[nodeKey],
      nodeKey: nodeKey
    });
  }));
}